import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useMemo } from "react"
import { UseDialogBajaContext } from "../DialogDetailBaja/components/DialogBajaContext"
import { accountingGet } from "../services/api"
import { formatMoney } from "#common/Funciones"

export default function Accounting() {
	const { baja } = UseDialogBajaContext()
	const params = useMemo(() => ({ id: baja.id }), [baja.id])
	const { data, error, loading } = useApi(accountingGet, {
		params,
		autoFetch: true,
	})

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />
	const { earnings = [], currency = "$" } = data || {}

	const items = [
		{ name: "name", label: "Nombre" },
		{
			name: "amount",
			label: "Monto",
			options: {
				customBodyRender: (value, datum) => formatMoney(value, currency),
			},
		},
		{ name: "concept_type_name", label: "Tipo" },
	]

	return <TableMain data={earnings} items={items} />
}
